//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions } from "vuex";
import { date } from "quasar";
import router from "../router";

export default {
  data() {
    return {
      orders: [],
      pickDayOptions: [],
      filter: "",

      pagination: {
        rowsPerPage: 6,
        page: 1,
        sortBy: "deliveryDate",
        descending: false,
      },
      columns: [
        {
          name: "orderNumber",
          align: "left",
          label: this.$t("order.orderNo"),
          field: "orderNumber",
          sortable: true,
        },
        {
          name: "customerName",
          align: "left",
          label: this.$t("order.customerName"),
          field: "customerName",
          sortable: true,
        },
        {
          name: "canDeliver",
          align: "left",
          label: "Kan leveres",
          field: "canDeliver",
          format: (val) => this.$t("common." + val),
          sortable: true,
        },
        {
          name: "urgent",
          align: "center",
          label: "Haster",
          style: "color: red; font-size:medium; font-weight: bold",
          field: "urgent",
          sortable: true,
        },
        {
          name: "deliveryDate",
          align: "left",
          label: this.$t("order.deliveryDate"),
          field: "deliveryDate",
          format: (val) => date.formatDate(val, "DD-MM-YYYY"),
          sortable: true,
        },
      ],
    };
  },
  async mounted() {
    await this.refresh();
  },

  methods: {
    ...mapActions("main", ["getOrdersByPickDay"]),

    async refresh() {
      this.orders = [];

      let daySelction = [
        "I dag",
        "I morgen",
        "Om 2 dager",
        "Om 3 dager",
        "Om 4 dager",
        "Om 5 dager",
        "Om 6 dager",
        "Om 7 dager",
      ];

      for (var i = 0; i < daySelction.length; i++) {
        this.pickDayOptions.push({
          value: i.toString(),
          label: daySelction[i],
        });
      }
      this.filter = this.pickDayOptions[0].value;

      this.orders = await this.getOrdersByPickDay(0);
      window.dispatchEvent(new Event("resize"));
    },

    openOrder(orderId) {
      router.push({ name: "Order", params: { id: orderId } });
    },

    async getOrders() {
      this.orders = await this.getOrdersByPickDay(parseInt(this.filter));
    },
  },
};
